import { apiClient } from './AbstractHTTPService'

const PATH = '/user/list/'

export default {

  getUser () {
    return apiClient.get(PATH)
  },

  getContact (user) {
    return apiClient.get('/user/contact/' + user.id + '/')
  },

  getDashboard () {
    return apiClient.get('/firmis/dashboard/')
  },

  login (payload) {
    return apiClient.post('/login/', payload)
  }
}
